// src/Pages/PatientDetails/printConfig.ts
import { Category, patientCategoryLabels } from "./Categories";
import { PrintColumn } from "../../Components/GenericPrintTable";

export const getPrintConfig = (
  category: Category,
  patientData: any,
  tableColumns: any[],
  tableData: any[],
  optionsPayload?: any,
) => {
  const isPatientCategory = category === "patient";

  // 1. Καρτέλα Ασθενή
  if (isPatientCategory) {
    const patientDetailsArray = patientData
      ? Object.entries(patientData)
          .filter(
            ([key]) =>
              !key.toLowerCase().includes("id") &&
              key !== "__v" &&
              key !== "allergies",
          )
          .map(([field, value]) => ({
            field: field.toUpperCase(),
            value: value !== null && value !== undefined ? String(value) : "-",
          }))
      : [];

    return {
      title: `Στοιχεία Ασθενή - ${patientData?.lastName || ""} ${patientData?.firstName || ""} (ΑΜΚΑ: ${patientData?.amka || "-"})`,
      data: patientDetailsArray,
      columns: [
        { header: "Πεδίο", accessor: "field" },
        { header: "Τιμή", accessor: "value" },
      ] as PrintColumn<any>[],
    };
  }

  // Κανονικοποίηση Options / Lookups
  const optionsList: any[] = Array.isArray(optionsPayload)
    ? optionsPayload
    : optionsPayload?.documentTypes || [];

  // 2. Κατασκευή Στηλών για το Modal
  const validColumns = tableColumns.filter(
    (col: any) =>
      col.id !== "select" &&
      col.id !== "actions" &&
      (col.id || col.accessorKey),
  );

  const printColumns: PrintColumn<any>[] = validColumns.map((col: any) => {
    const fieldId = col.id || col.accessorKey;
    return {
      header: typeof col.header === "string" ? col.header : fieldId,
      accessor: fieldId,
    };
  });

  // 3. Μετασχηματισμός των Δεδομένων (Mapped Data)
  // Μετατρέπουμε τα ID (π.χ. 1) στους πραγματικούς τίτλους (π.χ. "Μπάμπουρες") πριν τα στείλουμε στο Modal
  const formattedData = (tableData || []).map((row: any) => {
    const newRow: Record<string, any> = { ...row };

    validColumns.forEach((col: any) => {
      const fieldId = col.id || col.accessorKey;

      // Α) Αν η στήλη έχει accessorFn στο TanStack Table, την εκτελούμε
      if (typeof col.accessorFn === "function") {
        const fnVal = col.accessorFn(row);
        if (fnVal !== undefined && fnVal !== null && fnVal !== "") {
          newRow[fieldId] = String(fnVal);
          return;
        }
      }

      // Β) Αντιστοίχιση μέσω options (Lookups)
      const rawVal = row[fieldId];
      if (optionsList.length > 0 && rawVal !== undefined && rawVal !== null) {
        const matchedOpt = optionsList.find(
          (opt: any) =>
            String(opt.value) === String(rawVal) ||
            String(opt.id) === String(rawVal),
        );
        if (matchedOpt) {
          newRow[fieldId] =
            matchedOpt.label || matchedOpt.name || String(rawVal);
          return;
        }
      }

      // Γ) Direct Property / Boolean
      if (typeof rawVal === "boolean") {
        newRow[fieldId] = rawVal ? "Ναι" : "Όχι";
      } else if (rawVal === undefined || rawVal === null || rawVal === "") {
        newRow[fieldId] = "-";
      } else {
        newRow[fieldId] = String(rawVal);
      }
    });

    return newRow;
  });

  const categoryLabel = patientCategoryLabels[category] || category;

  return {
    title: `${categoryLabel} (Ασθενής: ${patientData?.lastName || ""} ${patientData?.firstName || ""}, ΑΜΚΑ: ${patientData?.amka || "-"})`,
    data: formattedData,
    columns: printColumns,
  };
};
